import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import WhatsAppButton from '../common/WhatsAppButton';
import ScrollToTop from '../common/ScrollToTop';

/**
 * Main layout component that wraps all pages
 */
const Layout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <ScrollToTop />
      <Header />
      
      <main className="flex-1">
        <Outlet />
      </main>
      
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Layout;
